module.exports = __webpack_public_path__ + "img/gourmetrda.57e3aab1.jpg";